import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const ThinkSeedWrapper = styled.div`
  padding: 20px 0;
`;

export const ThinkSeedHeader = styled.div`
height: 45px;
color: black;
font-size: 16px;
font-weight: bold;
display: flex;
margin-top: env(safe-area-inset-top);
align-items: center;

.arrowback {
  float: left;
  height: 45px;
  margin-left: 2rem;
}

div {
 float: left;
 width: 85%;
 height: 45px;
 padding: 15px 0px;

 @media (max-width: ${TABLET_WIDTH}px){
   width: 47vw;
 }
}

.search_lens {
 height: 45px;
 padding: 10px;
 @media (max-width: ${TABLET_WIDTH}px){
   margin-left: 11%;
 }
}

.infocircle {
  float: right;
  height: 45px;
  padding: 10px;
}
`;



// WEBPACK FOOTER //
// ./src/routes/ThinkSeedCreation/components/styles.js